import {
  downloadQuoteAttachment,
  listOrganizations,
  listQuoteAttachments,
  listReconciliationQuotes,
  listStatusesCount,
  removeQuoteAttachment,
  uploadQuoteAttachments,
  listPropertyQuotes,
} from '../thunks/reconciliation-quotes';
import { handlePending, handleRejected } from './utils';

export const reconciliationQuotesReducers = (builder) => {
  // list reconciliation quotes
  builder
    .addCase(listReconciliationQuotes.fulfilled, (state, action) => {
      const { data, fromFilter } = action.payload;
      state.quotes.value = data;
      state.quotes.fromFilter = fromFilter;
      state.quotes.loading = false;
    })
    .addCase(listReconciliationQuotes.pending, (state) => handlePending(state, 'quotes'))
    .addCase(listReconciliationQuotes.rejected, (state) => handleRejected(state, 'quotes'));

  // list property quotes
  builder
    .addCase(listPropertyQuotes.fulfilled, (state, action) => {
      const { propertyId, data } = action.payload;

      const existingContributions = state.propertyQuotes.value[propertyId]?.contributions || [];

      state.propertyQuotes.value[propertyId] = {
        quotes: data.map((quote) => ({ ...quote })),
        contributions: existingContributions,
      };

      state.propertyQuotes.loading[propertyId] = false;
    })
    .addCase(listPropertyQuotes.pending, (state, action) => {
      const propertyId = action.meta.arg.propertyId;
      state.propertyQuotes.loading[propertyId] = true;
    })
    .addCase(listPropertyQuotes.rejected, (state, action) => {
      const propertyId = action.meta.arg.propertyId;
      state.propertyQuotes.loading[propertyId] = false;
    });

  // list quote attachments
  builder
    .addCase(listQuoteAttachments.fulfilled, (state, action) => {
      state.quoteAttachments.value = action.payload;
      state.quoteAttachments.loading = false;
    })
    .addCase(listQuoteAttachments.pending, (state) => {
      state.quoteAttachments.loading = true;
    })
    .addCase(listQuoteAttachments.rejected, (state) => {
      state.quoteAttachments.loading = false;
    });

  // upload attachments
  builder
    .addCase(uploadQuoteAttachments.fulfilled, (state, action) => {
      const attachments = action.payload || [];
      state.quoteAttachments.value = [...state.quoteAttachments.value, ...attachments];
      state.quoteAttachments.updating = false;
    })
    .addCase(uploadQuoteAttachments.pending, (state) => {
      state.quoteAttachments.updating = true;
    })
    .addCase(uploadQuoteAttachments.rejected, (state) => {
      state.quoteAttachments.updating = false;
    });

  // download quote attachments
  builder
    .addCase(downloadQuoteAttachment.fulfilled, (state) => {
      state.quoteAttachments.updating = false;
    })
    .addCase(downloadQuoteAttachment.pending, (state) => {
      state.quoteAttachments.updating = true;
    })
    .addCase(downloadQuoteAttachment.rejected, (state) => {
      state.quoteAttachments.updating = false;
    });

  // list statuses count
  builder.addCase(listStatusesCount.fulfilled, (state, action) => {
    state.statusesCount.value = action.payload;
  });

  // remove quote attachment
  builder
    .addCase(removeQuoteAttachment.fulfilled, (state, action) => {
      const quoteAttachments = [...state.quoteAttachments.value];
      const attachmentId = action.payload;
      const attachmentIndex = quoteAttachments.findIndex((attachment) => attachment.id === attachmentId);
      if (attachmentIndex >= 0) {
        quoteAttachments.splice(attachmentIndex, 1);
        state.quoteAttachments.value = quoteAttachments;
      }
      state.quoteAttachments.updating = false;
    })
    .addCase(removeQuoteAttachment.pending, (state) => {
      state.quoteAttachments.updating = true;
    })
    .addCase(removeQuoteAttachment.rejected, (state) => {
      state.quoteAttachments.updating = false;
    });

  // list organizations admin
  builder.addCase(listOrganizations.fulfilled, (state, action) => {
    state.organizations.value = action.payload;
  });
};
